import {
  AnimatedSelect,
  AnimatedSelectProps,
  TextHeroSection,
  TextHeroSectionProps,
} from '@rimactechnology/rimac-ui-lib';

import {
  AnimatedSelectFragment,
  FooterQuery,
  HeroTextFragment,
  NavigationQuery,
  ProductImageBlockFragment,
  SeoFragment,
} from '@/api';
import { Layout } from '@/components/layout/Layout';
import { Seo } from '@/components/Seo';
import EnhancedProductImageBlock from '@/components/shared/EnhancedProductImageBlock';
import { ORIENTATION_TYPE } from '@/constants/constants';
import getCdlPublicId from '@/hooks/useCdlPublicId';
type Props = {
  seo?: SeoFragment | null;
  hero?: HeroTextFragment | null;
  animatedSelect?: AnimatedSelectFragment[] | null;
  productImageBlock?: ProductImageBlockFragment[] | null;
  header: NavigationQuery;
  footer: FooterQuery;
};

export const CompaniesPage = ({
  seo,
  hero,
  animatedSelect,
  productImageBlock,
  header,
  footer,
}: Props) => {
  const heroProps: TextHeroSectionProps = {
    title: hero?.title || '',
    text: hero?.text || '',
  };

  const animatedSelects: AnimatedSelectProps = {
    // anchor: animatedSelect.company?.data?.attributes?.anchor || undefined,
    selectOptions: (animatedSelect || []).map((item, index) => ({
      parentIndex: index || 1,
      image: {
        imgSrc: getCdlPublicId(
          item?.image?.img_desktop.data?.attributes?.url || '',
        ),
        imgSrcMobile: getCdlPublicId(
          item?.image?.img_mobile?.data?.attributes?.url || undefined,
        ),
        alt: item?.image?.alt || '',
        blurHash:
          item?.image?.img_desktop.data?.attributes?.blurhash ||
          'LAS?DV%M_3D%t7fQofj[~qM{4n-;',
      },
      title: item?.title || '',
      description: item?.text || '',
    })),
  };

  return (
    <Layout headerData={header} footerData={footer} invertedColor>
      <Seo seo={seo} />
      <TextHeroSection {...heroProps} />
      <AnimatedSelect
        {...animatedSelects}
        anchor="companies-select"
        isReducedHeight
      />
      {productImageBlock?.map((block, index) => (
        <EnhancedProductImageBlock
          key={`enhancedProductImageBlock-item-${index}`}
          productImageBlock={block}
          orientation={
            (index + 1) % 2 === 0
              ? ORIENTATION_TYPE.IMAGE_RIGHT
              : ORIENTATION_TYPE.IMAGE_LEFT
          }
          parentIndex={index}
        />
      ))}
    </Layout>
  );
};
